import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { 
  ChevronRight, 
  Users, 
  Newspaper, 
  Briefcase, 
  Globe, 
  Book, 
  Award, 
  ArrowRight, 
  Mail, 
  Menu, 
  X, 
  Twitter, 
  Linkedin, 
  Github 
} from 'lucide-react';

import Header from './components/Header';
import Footer from './components/Footer';
import ResourcesPage from './pages/ResourcesPage';
import EventsPage from './pages/EventsPage';
import HomePage from './pages/HomePage';
import CommunityPage from './pages/CommunityPage';
import TalentPage from './pages/TalentPage';
import NewsPage from './pages/NewsPage';

export {Hero};
export {FeaturedNews};
export {Features};
export {NewsletterSignup};

const Logo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 50" className="h-8 w-32">
    <g fill="none" stroke="#1E40AF" strokeWidth="2">
      <circle cx="25" cy="25" r="10"/>
      <line x1="35" y1="25" x2="55" y2="25"/>
      <circle cx="65" cy="25" r="10"/>
      <line x1="75" y1="25" x2="95" y2="25"/>
    </g>
    <text x="105" y="39" fill="#1E40AF" fontFamily="Arial" fontSize="40" fontWeight="bold">
      Qubiteers
    </text>
  </svg>
);

/*const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="fixed w-full bg-white/90 backdrop-blur-sm z-50 shadow-sm">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex-shrink-0">
            <a href="#" className="flex items-center space-x-2">
              <Logo />
            </a>
          </div>

          <div className="hidden md:flex md:items-center md:space-x-8">
            <a href="#" className="text-gray-700 hover:text-blue-600">News</a>
            <a href="#" className="text-gray-700 hover:text-blue-600">Community</a>
            <a href="#" className="text-gray-700 hover:text-blue-600">Careers</a>
            <a href="#" className="text-gray-700 hover:text-blue-600">Resources</a>
            <button className="rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
              Sign In
            </button>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="space-y-1 pb-3 pt-2">
              <a href="#" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">News</a>
              <a href="#" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">Community</a>
              <a href="#" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">Careers</a>
              <a href="#" className="block px-3 py-2 text-gray-700 hover:bg-gray-50">Resources</a>
              <button className="block w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
                Sign In
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};*/

const QuantumBackground = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-indigo-900/90" />
    <svg className="absolute w-full h-full opacity-10" viewBox="0 0 800 800">
      <g stroke="currentColor" strokeWidth="2" className="text-blue-200">
        {[...Array(10)].map((_, i) => (
          <g key={`h-${i}`}>
            <circle cx={80 * i + 40} cy="400" r="20" fill="none" />
            <line x1={80 * i + 60} y1="400" x2={80 * i + 100} y2="400" />
          </g>
        ))}
        {[...Array(10)].map((_, i) => (
          <g key={`v-${i}`}>
            <circle cx="400" cy={80 * i + 40} r="20" fill="none" />
            <line x1="400" y1={80 * i + 60} x2="400" y2={80 * i + 100} />
          </g>
        ))}
      </g>
      {[...Array(20)].map((_, i) => (
        <circle
          key={`p-${i}`}
          cx={Math.random() * 800}
          cy={Math.random() * 800}
          r="2"
          fill="#60A5FA"
          className="animate-pulse"
          style={{ animationDelay: `${Math.random() * 2}s` }}
        />
      ))}
    </svg>
  </div>
);

const Hero = () => (
  <div className="relative pt-24 min-h-screen">
    <QuantumBackground />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
      <h1 className="text-4xl font-bold mb-6 text-white">
        <span className="block">Where Quantum Minds</span>
        <span className="block text-blue-400">Unite and Innovate</span>
      </h1>
      <p className="text-xl mb-8 text-gray-300">Join the quantum computing revolution</p>
      <div className="flex justify-center gap-4">
        <button className="bg-blue-500 px-6 py-3 rounded-md flex items-center text-white hover:bg-blue-600 transition-colors">
          Join Community <ChevronRight className="ml-2" />
        </button>
        <button className="border border-white px-6 py-3 rounded-md text-white hover:bg-white/10 transition-colors">
          Explore News
        </button>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3">
        <div className="flex flex-col items-center">
          <Users className="h-12 w-12 text-blue-400" />
          <h3 className="mt-4 text-xl font-semibold text-white">Vibrant Community</h3>
          <p className="mt-2 text-gray-300">Connect with quantum computing professionals</p>
        </div>
        <div className="flex flex-col items-center">
          <Newspaper className="h-12 w-12 text-blue-400" />
          <h3 className="mt-4 text-xl font-semibold text-white">Latest Insights</h3>
          <p className="mt-2 text-gray-300">Stay updated with quantum breakthroughs</p>
        </div>
        <div className="flex flex-col items-center">
          <Briefcase className="h-12 w-12 text-blue-400" />
          <h3 className="mt-4 text-xl font-semibold text-white">Talent Fulfillment</h3>
          <p className="mt-2 text-gray-300">Find the talent your organization needs</p>
        </div>
      </div>
    </div>
  </div>
);

const FeaturedNews = () => {
  const articles = [
    {
      title: "Latest Breakthrough in Quantum Error Correction",
      excerpt: "Researchers achieve new milestone in quantum computing stability...",
      category: "Research"
    },
    {
      title: "Quantum Computing Investment Reaches New Heights",
      excerpt: "Global investment in quantum technology surpasses expectations...",
      category: "Industry"
    },
    {
      title: "The Rise of Quantum Software Development",
      excerpt: "New tools and platforms revolutionize quantum programming...",
      category: "Technology"
    }
  ];

  return (
    <div className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900">Latest in Quantum Computing</h2>
          <p className="mt-4 text-lg text-gray-600">Stay informed with cutting-edge developments</p>
        </div>
        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {articles.map((article, index) => (
            <div key={index} className="rounded-lg border p-6 hover:shadow-lg transition-shadow">
              <span className="text-sm font-medium text-blue-600">{article.category}</span>
              <h3 className="mt-2 text-xl font-semibold text-gray-900">{article.title}</h3>
              <p className="mt-3 text-gray-600">{article.excerpt}</p>
              <button className="mt-4 text-blue-600 flex items-center">
                Read more <ArrowRight className="ml-2 h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Features = () => {
  return (
    <div className="bg-gray-50 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          <div className="bg-white p-6 rounded-lg">
            <Globe className="h-8 w-8 text-blue-600" />
            <h3 className="mt-4 text-xl font-semibold">Global Community</h3>
            <p className="mt-2 text-gray-600">Connect with quantum enthusiasts worldwide</p>
          </div>
          <div className="bg-white p-6 rounded-lg">
            <Book className="h-8 w-8 text-blue-600" />
            <h3 className="mt-4 text-xl font-semibold">Expert Resources</h3>
            <p className="mt-2 text-gray-600">Access curated learning materials and tutorials</p>
          </div>
          <div className="bg-white p-6 rounded-lg">
            <Award className="h-8 w-8 text-blue-600" />
            <h3 className="mt-4 text-xl font-semibold">Talent Fulfillment</h3>
            <p className="mt-2 text-gray-600">Find the quantum computing skills your organization needs</p>
          </div>
        </div>
      </div>
    </div>
  );
};

const NewsletterSignup = () => {
  return (
    <div className="bg-blue-900 py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-white">Stay Quantum-Ready</h2>
          <p className="mt-4 text-lg text-gray-300">Get weekly updates on quantum computing news and opportunities</p>
          <div className="mt-8 flex max-w-md mx-auto gap-4">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 rounded-md px-4 py-2"
            />
            <button className="rounded-md bg-blue-500 px-6 py-2 text-white hover:bg-blue-600 flex items-center">
              Subscribe
              <Mail className="ml-2 h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

/*const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Logo />
            <p className="text-gray-400">Empowering the quantum computing community</p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-white">
                <Github size={20} />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">News</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Careers</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Contact</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">Documentation</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Tutorials</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Blog</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Community</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Terms of Service</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white">Cookie Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} Qubiteers. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};*/

/*const LandingPage = () => {
  return (
      <div className="min-h-screen">
        <Header />
        <div className="pt-16">
          <Hero />
          <FeaturedNews />
          <Features />
          <NewsletterSignup />
        </div>
        <Footer />
      </div>
  );
};*/

const App = () => {
  return (
    <Router>
      <div className="min-h-screen">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="community" element={<CommunityPage />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="resources" element={<ResourcesPage />} />
          <Route path="talent" element={<TalentPage />} />
          <Route path="news" element={<NewsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
